import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  BodyShort02,
  ProductiveHeading04,
  TextWrapper,
} from 'ozone/atoms/typography';
import { Heading, UnpaddedTextWrapper } from './components';

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const numbers = '0123456789';

const Box = styled(TextWrapper)`
  padding: ${({ theme }) => theme.spacing.normal};
  box-shadow: var(--shadow-02);
  margin-bottom: ${({ theme }) => theme.spacing.normal};
`;

const Body = styled(BodyShort02).attrs({ as: 'div' })`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Semibold = styled(Body)`
  font-weight: var(--font-weight-bold);
`;

const Light = styled(Body)`
  font-weight: 300;
`;

const FontLink = styled(Link).attrs({
  to: { pathname: 'https://github.com/ibm/plex' },
  target: '_blank',
})`
  margin: ${({
      theme: {
        spacing: { quarter },
      },
    }) => quarter}
    0;
  display: block;
`;

export const Typeface: FC = () => (
  <>
    <Heading>Typeface</Heading>
    <UnpaddedTextWrapper>
      <FontLink>
        <Body>IBM Plex</Body>
      </FontLink>
    </UnpaddedTextWrapper>
    <Box>
      <ProductiveHeading04>IBM Plex Sans</ProductiveHeading04>
      <br />
      <Semibold>
        {alphabets}
        <br />
        {alphabets.toLowerCase()}
        <br />
        {numbers}
      </Semibold>
      <Body>
        {alphabets}
        <br />
        {alphabets.toLowerCase()}
        <br />
        {numbers}
      </Body>
      <Light>
        {alphabets}
        <br />
        {alphabets.toLowerCase()}
        <br />
        {numbers}
      </Light>
    </Box>
  </>
);
